import {CommentsCategory, useComments, type CommentDto} from '@domain/comments'
import {useUpmPlantContext} from '@hconnect/upm'
import {keepPreviousData} from '@tanstack/react-query'

export const useScheduleCommentsByScheduleItemId = (
  scheduleItemsIds: string[],
  isDisabled = false
) => {
  const {plantId} = useUpmPlantContext()

  return useComments(
    {
      plantId,
      commentCategoryInstanceIds: scheduleItemsIds,
      commentsCategory: CommentsCategory.AssetOperationTimes
    },
    'comments',
    {
      select: (comments: CommentDto[]) =>
        comments.reduce(
          (acc, current) => {
            // NOTE: only one comment is possible per schedule item
            acc[current.commentsCategoryInstanceId] = current
            return acc
          },
          {} as Record<string, CommentDto>
        ),
      placeholderData: keepPreviousData,
      enabled: scheduleItemsIds.length > 0 && !isDisabled
    }
  )
}
